import type { OptionKV } from "~styled/selector/Selector";

export enum ECondicionFiscal {
  Monotributista = "Monotributista",
  ResponsableInscripto = "ResponsableInscripto",
  IvaExento = "IvaExento",
  ConsumidorFinal = "ConsumidorFinal",
}

const TODAS = "";
export const MONOTRIBUTISTA = ECondicionFiscal.Monotributista;
export const RESPONSABLEINSCRIPTO = ECondicionFiscal.ResponsableInscripto;
export const IVAEXENTO = ECondicionFiscal.IvaExento;
export const CONSUMIDORFINAL = ECondicionFiscal.ConsumidorFinal;

const condicionesFiscalesOptions: Record<
  ECondicionFiscal | typeof TODAS,
  string
> = {
  [TODAS]: "Todas",
  [MONOTRIBUTISTA]: "Monotributista",
  [RESPONSABLEINSCRIPTO]: "Responsable Inscripto",
  [IVAEXENTO]: "Iva Exento",
  [CONSUMIDORFINAL]: "Consumidor Final",
};

const condicionesFiscalesFilter: OptionKV<ECondicionFiscal | typeof TODAS>[] = [
  { label: condicionesFiscalesOptions[TODAS], value: TODAS },
  { label: condicionesFiscalesOptions[MONOTRIBUTISTA], value: MONOTRIBUTISTA },
  {
    label: condicionesFiscalesOptions[RESPONSABLEINSCRIPTO],
    value: RESPONSABLEINSCRIPTO,
  },
  {
    label: condicionesFiscalesOptions[IVAEXENTO],
    value: IVAEXENTO,
  },
];

export { condicionesFiscalesOptions, condicionesFiscalesFilter };
